import React, { Component } from "react";
import { connect } from "react-redux";

class Text extends Component {
    constructor(props) {
        super(props);
        this.change = this.change.bind(this);
        this.blur = this.blur.bind(this);
    }

    change(e) {
        this.props.dispatch(this.props.action(e.target.value));
    }

    blur(e) {
        let value = e.target.value;
        if (isNaN(value)) this.props.dispatch(this.props.action(0));
    }

    render() {
        const blank = this.props.blank ? "l-blank" : "";
        const mt = this.props.mt ? " l-mtSS" : "";
        const wrapStyle = blank + mt;

        return (
            <div className={wrapStyle}>
                <label>{this.props.label + "："}</label>
                <input
                    className={this.props.class}
                    type="text"
                    value={this.props.value}
                    onBlur={this.props.type === "number" && this.blur}
                    onChange={this.props.action === null ? this.props.change : this.change}
                />
            </div>
        );
    }
}

export default connect()(Text);
